const settings = {
    clockShowSeconds: false,
    fireworkSettings: {
            hue: {
                min: 0,
                max: 345
            },
            acceleration: 1.05,
            
            brightness: {
                min: 50,
                max: 80
            },
            decay: {
                min: 0.015,
                max: 0.03
            },
            delay: {
                min: 30,
                max: 60
            },
            explosion: 5,
            flickering: 50,
            intensity: 30,
            friction: 0.97,
            gravity: 1.5,
            opacity: 0.5,
            particles: 60,
            traceLength: 3,
            traceSpeed: 10,
            rocketsPoint: {
                min: 50,
                max: 50
            },
            lineWidth: {
                explosion: {
                   min: 1,
                    max: 4
                },
                trace: {
                    min: 0.1,
                    max: 1
                }
            },
            lineStyle: 'round',
        }
};

export {settings}